export default {
  data() {
    return {
      isAtTop: true,
      isAtBottom: false,
    };
  },

  methods: {
    /**
     * Met a jour l'etat des boutons de navigation selon la position de scroll.
     * @returns {void}
     */
    handleScroll() {
      const container = this.$refs.scrollContainer;
      if (!container) return;

      this.isAtTop = container.scrollTop === 0;
      this.isAtBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - 10;
    },

    /**
     * Fait defiler la liste jusqu'en haut.
     * @returns {void}
     */
    scrollToTop() {
      const container = this.$refs.scrollContainer;
      if (!container) return;

      container.scrollTo({ top: 0, behavior: 'smooth' });
    },

    /**
     * Fait defiler la liste jusqu'en bas.
     * @returns {void}
     */
    scrollToBottom() {
      const container = this.$refs.scrollContainer;
      if (!container) return;

      container.scrollTo({ top: container.scrollHeight, behavior: 'smooth' });
    },
  },
};
